import React, { useEffect, useContext } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  Navigate
} from "react-router-dom";
import Header from "./components/Header"; // Header Component
import Footer from "./components/Footer"; // Footer Component
import Home from "./pages/Home"; // Home Page
import About from "./pages/About"; // About Page
import NotFound from "./pages/NotFound"; // Not Found Page
import { AppContextProvider, AppContext } from "./context/AppContext"; // Context for global state
import Login from "./pages/Login"; // Login Page
import ForgotPassword from "./pages/ForgotPassword"; // forgot Page
import Welcome from "./pages/welcome"; // welcome
import DocumentTypeForm from "./pages/documentselector"; // Document Type Selector Page
import FeedbackForm from "./context/Feedback"; // Feedback Form
import PolicyForm from "./pages/Policyform"; // Policy Form
import ProtectedRoute from "./components/ProtectedRoute"; // Protected Route Component
import ResetPassword from "./pages/resetPassword";
import ResetPass from "./pages/resetPassByUniqId";
import Refine from "./pages/refine"
import ScreenshotPage from "./pages/EmailReferences";
import EditRefine from "./pages/EditRefine";
import Profile from "./pages/Profile";
import SessionHistory from "./pages/SessionHistory";
import ChangePassSuccess from "./pages/successChangePass";
import ChatHistory from "./pages/ChatHistory";
import Course from "./pages/LMS/Course";
import QuizeStepper from "./pages/LMS/QuizeStepper";
import DashboardCourses from "./pages/LMS/DashboardCourses";
import { useTranslation } from "react-i18next";
import Module from "./pages/LMS/Module";
import DocumentView from "./pages/LMS/DocumentView";
import AllCourses from "./pages/LMS/AllCourses";
import UserCertificatePage from "./pages/LMS/UserCertificatePage";
import CertificateGenerator from "./components/certificateGenerator";
import ResetPasswordByEmail from "./pages/resetPassByEmail";
import Dashboard from "./pages/dashboard";
import MeetingsList from "./pages/meetiingList";


function App() {

  const { setUserData, setLoading, userData } = useContext(AppContext);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      const storedUserData = localStorage.getItem("user") || sessionStorage.getItem("user");
      const storedToken = localStorage.getItem("token") || sessionStorage.getItem("token");

      // Check if both user and token are present
      if (storedUserData && storedToken) {
        try {
          setUserData(JSON.parse(storedUserData)); // Parse and set user data
        } catch (error) {
          console.error("Error parsing user data:", error);
          setUserData(null); // Reset if parsing fails
        }
      } else {
        setUserData(null); // No user data or token found
      }
      setLoading(false);
    }, 1000);
  }, [setUserData, setLoading]);

  return (
    <AppContextProvider>
      <Router>
        <AppContent userData={userData} />
      </Router>
    </AppContextProvider>
  );
}

// Custom route component to redirect logged in users from login page
const PublicRoute = ({ children }) => {
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  if (token) {
    return <Navigate to="/welcome" replace />;
  }
  return children;
};

function AppContent({ userData }) {

  const location = useLocation(); // Get the current location (path)
  const { i18n } = useTranslation();
  const [dir, setDir] = React.useState("ltr");

  useEffect(() => {
    if (i18n.language === "ar") {
      setDir("rtl");
    } else {
      setDir("ltr");
    }
  }, [i18n.language]);

  useEffect(() => {
    const formatTitle = (path) => {
      const segments = path
        .replace(/^\/+/, "")
        .split("/")
        .filter(Boolean);

      if (segments.length === 0) return "Home";

      // Take last 2 segments
      const lastTwo = segments.slice(-2);

      return lastTwo
        .map(segment =>
          segment
            .split("-")
            .map(
              word =>
                word.charAt(0).toUpperCase() + word.slice(1)
            )
            .join(" ")
        )
        .join(" | ");
    };

    document.title = formatTitle(location.pathname);
  }, [location.pathname]);

  return (
    <div className={`App ${dir === 'rtl' ? 'body-ar' : 'body-en'}`}>
      {!(
        location.pathname === "/login" ||
        location.pathname === "/change-password" ||
        location.pathname === "/forgot-password" ||
        location.pathname === "/welcome" ||
        location.pathname === "/change-pass-success" ||
        location.pathname === "/resetPasswordByEmail" ||
        location.pathname === "/reset-password" ||
        location.pathname === "/lms/quize"
      ) && <Header dir={dir} />}

      {/* Main Layout Container */}
      <div className="flex"> {/* pt-16 for header height */}
        {/* Content Area - Will auto adjust based on sidebar state */}
        <main className="flex-1 transition-all duration-300">
          <Routes>
            {/* Public Routes with login check */}
            <Route path="/login" element={
              <PublicRoute>
                <Login dir={dir} />
              </PublicRoute>
            } />

            <Route path="/change-password" element={<ResetPassword dir={dir} />} />
            <Route path="/reset-password" element={<ResetPass dir={dir} />} />
            <Route path="/resetPasswordByEmail" element={<ResetPasswordByEmail dir={dir} />} />
            <Route path="/forgot-password" element={<ForgotPassword dir={dir} />} />
            <Route path="/change-pass-success" element={<ChangePassSuccess dir={dir} />} />
            <Route path="/about" element={<About dir={dir} />} />

            {/* Protected Routes */}
            <Route
              path="/generate-certificate"
              element={
                <ProtectedRoute userData={userData}>
                  <CertificateGenerator dir={dir} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/"
              element={
                <ProtectedRoute userData={userData}>
                  <Home dir={dir} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/references-email"
              element={
                <ProtectedRoute userData={userData}>
                  <ScreenshotPage dir={dir} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/doc"
              element={
                <ProtectedRoute userData={userData}>
                  <DocumentTypeForm dir={dir} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/feedback"
              element={
                <ProtectedRoute userData={userData}>
                  <FeedbackForm dir={dir} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/policy"
              element={
                <ProtectedRoute userData={userData}>
                  <PolicyForm dir={dir} />
                </ProtectedRoute>
              }
            />
            {/* refine it */}
            <Route
              path="/refine"
              element={
                <ProtectedRoute userData={userData}>
                  <Refine dir={dir} />
                </ProtectedRoute>
              }
            />
            {/* edit refine */}
            <Route
              path="/edit-refine"
              element={
                <ProtectedRoute userData={userData}>
                  <EditRefine dir={dir} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/welcome"
              element={
                <ProtectedRoute userData={userData}>
                  <Welcome dir={dir} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute userData={userData}>
                  <Profile dir={dir} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/session-history"
              element={
                <ProtectedRoute userData={userData}>
                  <SessionHistory dir={dir} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/meeting-list"
              element={
                <ProtectedRoute userData={userData}>
                  <MeetingsList dir={dir} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lms/dashboard"
              element={
                <ProtectedRoute userData={userData}>
                  <Dashboard dir={dir} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lms/courses"
              element={
                <ProtectedRoute userData={userData}>
                  <DashboardCourses dir={dir} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lms/userCertificates"
              element={
                <ProtectedRoute userData={userData}>
                  <UserCertificatePage dir={dir} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lms/dashboard/course"
              element={
                <ProtectedRoute userData={userData}>
                  <Course dir={dir} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lms/all-courses"
              element={
                <ProtectedRoute userData={userData}>
                  <AllCourses dir={dir} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lms/course"
              element={
                <ProtectedRoute userData={userData}>
                  <Module dir={dir} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lms/dashboard/ContentView"
              element={
                <ProtectedRoute userData={userData}>
                  <DocumentView dir={dir} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lms/quize"
              element={
                <ProtectedRoute userData={userData}>
                  <QuizeStepper dir={dir} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/session/:sessionName"
              element={
                <ProtectedRoute userData={userData}>
                  <ChatHistory dir={dir} />
                </ProtectedRoute>
              }
            />
            {/* 404 Page */}
            <Route
              path="*"
              element={
                <ProtectedRoute userData={userData}>
                  <NotFound dir={dir} />
                </ProtectedRoute>
              }
            />
          </Routes>
        </main>
      </div>

      {/* Conditionally render Footer if userData exists and the path is not /login */}
      {userData &&
        !(
          location.pathname === "/login" ||
          location.pathname === "/change-password"
        ) && <Footer dir={dir} />}
    </div>
  );
}

export default App;